import { LinkContainer } from "react-router-bootstrap";
import { Job } from "../../libs/shared/model";

export default function JobLinkContainer({item, ...props}){
    return(
        <LinkContainer to={item.status === Job.jobStatusTypes.POSTED ? `/organisations/${item.orgId}/jobs/${item.jobId}/review` : `/organisations/${item.orgId}/jobs/${item.jobId}/edit`}>
            {props.children}
        </LinkContainer>
    )
}